import { createFileRoute } from '@tanstack/react-router'
import CandidateAssessment from '@/pages/candidate-assessment'

export const Route = createFileRoute(
  '/_authenticated/assessments/$assessmentsId'
)({
  component: CandidateAssessment,
})
